import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import FilterTogglebar from "../common/FilterTogglebar";
import CitiesView from "./CitiesView";
// import { cities } from "./constants";
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import { charts } from "./constants";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import CitiesViewResponsive from './CitiesViewResponsive';

const CitiesContainer = () => {
  const {
    loadCities,
    loadCityMetrics,
    setSelectedCity,
    resetWaterUserChart,
    resetSelectedCity,
    setScenario,
    loadCityAvailableWater,
    loadAllCitiesWaterUse,
  } = userActions();
  const { cities, city_selected, scenario, chart_selected } = useSelector(
    (state) => state.water_user
  );
  const { isMobile } = useGetViewPortDimensions();

  const handleChange = (value, scenario_idx) => {
    loadCityMetrics(value);
    setSelectedCity(cities[value - 1]); //the cities array index is 1 below the city value
    setScenario(scenario_idx);
    // Entitlement csv uses scenario names instead of index
  };

  const loadCityWater = () => {
    const scenarioMapper = {
      1: "DCP Cuts",
      2: "Deeper Cuts",
    };
    loadCityAvailableWater(city_selected.name, scenarioMapper[scenario]);
  }
  useEffect(loadCityWater, [city_selected, scenario]);

  const componentMount = () => {
    // setSelectedCity({ label: "Phoenix", value: 32 });
    loadCities();
    loadAllCitiesWaterUse();
    loadCityMetrics(1); //as default, we will show the information for the first item in the dropdown menu
    return () => {
      resetWaterUserChart();
      resetSelectedCity();
      setScenario(1);
    };
  }
  useEffect(componentMount, []);

  return (
    <Grid container>
      {!isMobile && <FilterTogglebar
        options={cities}
        title={`Water User: ${city_selected.name}`}
        handleChange={handleChange}
        value={city_selected.city_id}
        scenario_disabled={charts[chart_selected].scenario_disabled}
        water_user_disabled={charts[chart_selected].water_user_disabled}
      />}
      {isMobile ? <CitiesViewResponsive /> : <CitiesView />}
    </Grid>
  );
};

export default CitiesContainer;
